import React from 'react'
import moment from 'moment'
import { statusEnumSQ } from '../enums/statusEnumSQ'
import './ApplicantHistoryLegend.css'

const ApplicantHistoryLegend = ({ history, loading }) => {
  if (loading) {
    return (
      <div className='history-legend-container'>
        <div className='history-legend-header'>
          <h5>Status History</h5>
        </div>
        <div className='history-legend-body'>
          <p className='text-muted text-center'>Loading history...</p>
        </div>
      </div>
    )
  }

  if (!history || history.length === 0) {
    return (
      <div className='history-legend-container'>
        <div className='history-legend-header'>
          <h5>Status History</h5>
        </div>
        <div className='history-legend-body'>
          <p className='text-muted text-center'>No status changes recorded yet.</p>
        </div>
      </div>
    )
  }

  // Build the path from oldest to newest (just the to_status changes)
  const reversedHistory = [...history].reverse()

  return (
    <div className='history-legend-container'>
      <div className='history-legend-header'>
        <h5>Status History Timeline</h5>
        <span className='history-count'>{reversedHistory.length} changes</span>
      </div>
      <div className='history-legend-body'>
        <div className='steps-container'>
          {reversedHistory.map((item, index) => (
            <React.Fragment key={index}>
              <div className='step-item'>
                <div className='step-number'>{index + 1}</div>
                <div className='step-status'>
                  <span className='status-badge'>{statusEnumSQ[item.to_status] || item.to_status}</span>
                </div>
                <div className='step-details'>
                  <div className='step-date'>{moment(item.changed_at).format('DD MMM YYYY')}</div>
                  <div className='step-time'>{moment(item.changed_at).format('HH:mm')}</div>
                  {item.changed_by && (
                    <div className='step-user'>
                      <span className='user-label'>Changed by:</span>
                      <span className='user-name'>{item.changed_by.first_name} {item.changed_by.last_name}</span>
                    </div>
                  )}
                </div>
              </div>
              {index < reversedHistory.length - 1 && (
                <div className='step-connector'>
                  <svg width="40" height="24" viewBox="0 0 40 24">
                    <path d="M0 12h40M40 12l-6-6M40 12l-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </div>
  )
}

export default ApplicantHistoryLegend
